import { parseISO, format, parse } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const DateUtils = {
  FormatLocalDate(date) {
    if (!date || date === '0001-01-01T00:00:00+00:00') return '';
    try {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Try to parse as ISO first
      const parsedISO = parseISO(date);
      if (!isNaN(parsedISO)) {
        const zoned = utcToZonedTime(parsedISO, timeZone);
        return format(zoned, 'MM/dd/yyyy');
      }

      // Fallback: parse with known format if not ISO
      const parsedFallback = parse(date, 'MM/dd/yyyy hh:mm:ss a XXX', new Date());
      if (!isNaN(parsedFallback)) {
        const zoned = utcToZonedTime(parsedFallback, timeZone);
        return format(zoned, 'MM/dd/yyyy');
      }

      return date; // Fallback return original if invalid
    } catch {
      return date; // Fallback return original on error
    }
  }
};

export default DateUtils;
